module.exports = __webpack_public_path__ + "static/media/pool_jeff.990e8e15.jpg";